'use client';

import Link from '@/components/Link';
import {ArrowRight} from 'lucide-react';
import {PAY_DOMAIN} from '@/lib/landing/constants';
import {developersContent} from '@/lib/landing/content';
import {cardHoverClass, FadeIn, sectionBorderDark, sectionPadding, SectionBadge, SectionContainer} from './shared';

export function DeveloperSection() {
  return (
    <section id={developersContent.id} aria-labelledby="developers-heading" className={`${sectionPadding} bg-kobra-dark ${sectionBorderDark} text-white overflow-hidden relative`}>
      <SectionContainer>
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <FadeIn>
            <div>
              <SectionBadge dark>Developers</SectionBadge>
              <h2 id="developers-heading" className="text-3xl md:text-4xl font-bold mb-6">
                {developersContent.title}
              </h2>
              <p className="text-kobra-text-muted-light text-lg mb-8 leading-relaxed">
                {developersContent.description}
              </p>
              <p className="text-kobra-accent text-sm font-medium mb-6">{developersContent.integrationNote}</p>
              <ul className="flex flex-wrap gap-2 mb-8">
                {developersContent.features.map((feature) => (
                  <li
                    key={feature}
                    className="text-xs font-medium text-kobra-text-muted-light bg-kobra-surface border border-kobra-border-dark px-3 py-1.5 rounded-full"
                  >
                    {feature}
                  </li>
                ))}
              </ul>
              <Link
                href="#docs"
                className="text-kobra-accent hover:text-white font-semibold inline-flex items-center gap-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kobra-accent rounded"
              >
                Explorar la documentación
                <ArrowRight className="w-5 h-5" aria-hidden="true" />
              </Link>
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="space-y-4">
              <div className={`bg-kobra-surface border border-kobra-border-dark rounded-xl overflow-hidden hover:border-kobra-accent/30 ${cardHoverClass}`}>
                <div className="bg-kobra-surface-elevated px-4 py-2 text-xs text-kobra-text-muted-light font-mono border-b border-kobra-border-dark">
                  Ejemplo conceptual · TypeScript
                </div>
                <div className="p-4 overflow-x-auto text-[13px] font-mono leading-relaxed text-kobra-text-muted-light">
                  <pre>
                    <code>{`const paymentIntent = await kobra.paymentIntents.create({
  amount: 1250000,
  currency: "COP",
  reference: "ORD-1029",
  metadata: {
    customerId: "CLI-501",
    orderId: "ORD-1029"
  },
  callbackUrl: "https://api.miempresa.com/webhooks/kobra"
});`}</code>
                  </pre>
                </div>
              </div>

              <div className={`bg-kobra-surface border border-kobra-border-dark rounded-xl overflow-hidden lg:ml-6 hover:border-kobra-accent/30 ${cardHoverClass}`}>
                <div className="bg-kobra-surface-elevated px-4 py-2 text-xs text-kobra-text-muted-light font-mono border-b border-kobra-border-dark flex justify-between">
                  <span>Respuesta HTTP 201</span>
                  <span className="text-kobra-accent">JSON</span>
                </div>
                <div className="p-4 overflow-x-auto text-[13px] font-mono leading-relaxed text-kobra-text-muted-light">
                  <pre>
                    <code>{`{
  "id": "pi_01JX9K8",
  "status": "pending",
  "amount": 1250000,
  "currency": "COP",
  "reference": "ORD-1029",
  "checkoutUrl": "${PAY_DOMAIN}/pay/pi_01JX9K8"
}`}</code>
                  </pre>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </SectionContainer>
    </section>
  );
}
